import { useSearchParams } from 'react-router-dom';
import useFetchUserRegistrationDetails from './useFetchUserRegistrationDetails';

const useLoginFormInitialValue = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const { isFetching, userRegistrationDetails } =
    // @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    useFetchUserRegistrationDetails(code);

  const { email, registrationToken } = userRegistrationDetails || {};

  return {
    isLoading: isFetching,
    initialValue: {
      email,
      registrationToken,
      rememberMe: !!localStorage.getItem('remember_me'),
    },
  };
};

export default useLoginFormInitialValue;
